import { SET_OPTIONS } from './mutations'

export default {
  setOptions: ({ commit }, options) => {
    commit(SET_OPTIONS, options)
  }
}
